// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".confirmation-dialog__actions--cancel{margin-right:12px}.confirmation-dialog__contents{word-break:normal;word-wrap:break-word}", ""]);
// Exports
module.exports = exports;
